var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBountiesSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_5145_24902)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.2647H23.6176C24.6572 22.2647 25.5 21.4219 25.5 20.3824C25.5 19.3428 24.6572 18.5 23.6176 18.5H19V22.2647ZM19 22.2647L24.1176 22.2646C25.1572 22.2646 26 23.1074 26 24.147C26 25.1866 25.1572 26.0294 24.1176 26.0294H19V22.2647ZM17.5 30.5H26.5C28.7091 30.5 30.5 28.7091 30.5 26.5V17.5C30.5 15.2909 28.7091 13.5 26.5 13.5H17.5C15.2909 13.5 13.5 15.2909 13.5 17.5V26.5C13.5 28.7091 15.2909 30.5 17.5 30.5Z",
    stroke: "#1B202C",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5145_24902",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBountiesSquare);
export default __webpack_public_path__ + "static/media/bounties-square.79b9d2e5271d45b1d08cbd4a4df2aede.svg";
export { ForwardRef as ReactComponent };